var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"v-carousel-item",class:{ reverse: _vm.reverse }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }